(function($){
  'use strict';

  if(!$.gnv){
      $.gnv = new Object();
  };

  $.gnv.spotScrollLean = function(){
    var base = this;

    base.spotsArray = [];
    base.nChilds = 0;
    base.$el = $('.js-spot-svg').last();
    base.totalHeight = 0

    base.init = function(){

      if ($(window).width() > 768) {
        base.run();
      }

    };

    base.setSpotPosition = function() {
      base.spotsArray = [];
      base.nChilds = 0;
      $('.js-spot-image').each(function(i, el){
        base.spotsArray[i] = [];
        base.spotsArray[i]['top'] = $(el).offset().top;
        base.nChilds++;

        if(i == base.nChilds-1)
          base.totalHeight = base.spotsArray[i]['top']-base.spotsArray[0]['top'];
      });
    };

    base.run = function(){
      var top = $(window).scrollTop();
      base.setSpotPosition();

      if (top >= base.spotsArray[0]['top'] && top < base.spotsArray[base.nChilds-1]['top']) {
        var x = (top-base.spotsArray[0]['top'])*100/(base.totalHeight-300);

        base.$el.addClass('fixed');

        if(x <= 100)
          base.$el.find('#path-hover').css('strokeDashoffset',1300/100*x);

        if(parseFloat(x) > 25){
          base.$el.find('#arrow-1').show();
          base.$el.find('svg').addClass('step1');
        } else {
          base.$el.find('#arrow-1').hide();
          base.$el.find('svg').removeClass('step1');
        }

        if(parseFloat(x) > 50){
          base.$el.find('#arrow-2').show();
          base.$el.find('svg').addClass('step2');
        } else {
          base.$el.find('#arrow-2').hide();
          base.$el.find('svg').removeClass('step2');
        }

        if(parseFloat(x) > 75){
          base.$el.find('#arrow-3').show();
          base.$el.find('svg').addClass('step3');
        } else {
          base.$el.find('#arrow-3').hide();
          base.$el.find('svg').removeClass('step3');
        }

        if(parseFloat(x) > 100){
          base.$el.find('#arrow-4').show();
          base.$el.find('svg').addClass('step4');
        } else {
          base.$el.find('#arrow-4').hide();
          base.$el.find('svg').removeClass('step4');
        }
      } else {
        base.$el.removeClass('fixed');
      }
    };

    base.init();

    $(window).on('scroll touchmove', function(){
      if ($(window).width() > 768) {
        base.run();
      };
    });

    $(window).on('resize', function(){
      if ($(window).width() > 768) {
        base.run();
      } else {
        base.$el.removeClass('fixed');
      }
    });

  };

  $( document ).ready(function() {
    if($('.js-spot-image').length && $('.js-spot-svg').length)
      $.gnv.spotScrollLean();
  });

})(jQuery);




